import { Constants } from "customer-sdk/constants";

const VALIDATIONS = Constants.VALIDATIONS;
/**
 * @class ValidationHelper
 * @description Helper class used for validating values.
 * @author Kelvin John Santos
 * @version 1.0
 * @since January 10, 2019
 */
export default class ValidationHelper {
  /**
   * @function getTruthyOrNull
   * @description Method used for retrieving truthy value, otherwise it returns null.
   * @param {Any} value Value subjected for testing.
   * @returns {Any} Result of validation process.
   * @memberof ValidationHelper
   */
  getTruthyOrNull(value) {
    if (value && value !== null && value !== "null" && value !== undefined && value !== "undefined") {
      return value;
    }
    return null;
  }

  /**
   * @function checkIfDefined
   * @description Method used for checking if value is defined or not.
   * @param {Any} value Value subjected for testing.
   * @returns {Boolean} Flag that indicates if value is not set to "undefined".
   * @memberof ValidationHelper
   */
  checkIfDefined(value) {
    return typeof value !== "undefined";
  }

  checkIfUndefinedOrNull(value) {
    return value == undefined || value == null;
  }

  /**
   * @function validateEmailIfNotEmpty
   * @description Method used for validating an email if it is not empty.
   * @param {String} email String that would be subjected to testing.
   * @returns {Boolean} Flag that indicates if the email is valid or not.
   * @memberof ValidationHelper
   */
  validateEmailNotEmpty(email) {
    if (email) {
      return VALIDATIONS.EMAIL_VALIDATION_REGEX.test(email);
    } else {
      return true;
    }
  }

  /**
   * @function checkObjectExistAndNotEmpty
   * @description Method used for checking if an object's property exists and not empty.
   * @param {Object} object
   * @param {String} key
   * @returns {Boolean} Flag that indicates if key is existing and has properties inside.
   * @memberof ValidationHelper
   */
  checkObjectExistAndNotEmpty(object, key) {
    // eslint-disable-next-line no-prototype-builtins
    if (typeof object === "object" && object.hasOwnProperty(key)) {
      if (Object.keys(object[key]).length >= 1) {
        return true;
      }
    }
    return null;
  }

  /**
   * @function isNumberInput
   * @description Method used for limiting v-text-field to numbers only without using number model
   * this also excludes "e" which is actually on the html spec that allows type="number" on input field
   * to work. Usually added on v-text-field v-on:keypress="isNumberInput($event)"
   * @param {evt} object KeyboardEvent $event passed on :keypress
   * @returns {Boolean} Flag that indicates if the key event is allowed
   * @memberof ValidationHelper
   */
  isNumberInput(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * @function numberWithCommas
   * @description Method used for seperating thousand values by comma.
   * @param {value} String Number value
   * @returns {String} Number with commas as separators
   * @memberof ValidationHelper
   */
  numberWithCommas(value) {
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  validateCountry = (input) => {
    // If the country is empty.
    if (!input) {
      return "Required.";
    }
    // If the country is invalid.
    // eslint-disable-next-line no-prototype-builtins
    if (!input.hasOwnProperty("value")) {
      return "Invalid country.";
    }
    // eslint-disable-next-line no-prototype-builtins
    if (input.hasOwnProperty("value")) {
      return !!input.value || "Required.";
    }
  };

  /**
   * @function isFieldRequired
   * @description Method used for validating required fields.
   * @param {value} Boolean Number value
   * @returns {String} String valiation message
   * @memberof ValidationHelper
   */
  isFieldRequired = (isCountry) => {
    if (isCountry) return [(input) => this.validateCountry(input)];
    return [(input) => !!input || "Required."];
  };
}
